import {
  faCheckCircle,
  faClock,
  faExclamationTriangle,
  faQuestionCircle,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';

// TODO: REPLACE MOCK DATA BOSON-333
// Mock procedure codes
export const mockProcedureCodes = ['D6740', 'D2950', 'D2356'];

// TODO: REPLACE MOCK DATA BOSON-333
// Mock payer names
export const mockPayerNames = [
  'Delta Dental of Massachusetts',
  'MetLife',
  'Delta Dental of Rhode Island',
  'Cigna',
  'Blue Cross of California',
  'Aetna',
];

// TODO: REPLACE MOCK DATA BOSON-333
// Mock insurance statuses
export const mockInsuranceStatuses = [
  { status: 'Active', variant: 'success' as const },
  { status: 'Inactive', variant: 'error' as const },
  { status: 'Pending', icon: faClock },
  { status: 'Unknown', variant: 'warning' as const },
];

// TODO: REPLACE MOCK DATA BOSON-333
// Generate stable insurance status for each appointment
export const getMockAppointmentInsuranceStatus = (appointmentId: string) => {
  const statuses = ['active', 'inactive', 'pending', 'unknown'];

  // Use appointment ID to create a deterministic status
  const hash = appointmentId.split('').reduce((a, b) => {
    a = ((a << 5) - a + b.charCodeAt(0)) & 0xffffffff;
    return a;
  }, 0);
  const statusIndex = Math.abs(hash) % statuses.length;
  return statuses[statusIndex];
};

// TODO: REPLACE MOCK DATA BOSON-333
// Mock verification statuses
export const mockVerificationStatuses = [
  {
    status: 'Verified',
    icon: faCheckCircle,
    iconColor: 'vai-text-green-600',
  },
  {
    status: 'Failed',
    icon: faTimesCircle,
    iconColor: 'vai-text-red-600',
  },
  {
    status: 'Missing data',
    icon: faQuestionCircle,
    iconColor: 'vai-text-amber-500',
  },
  {
    status: 'Needs attention',
    icon: faExclamationTriangle,
    iconColor: 'vai-text-amber-500',
  },
  {
    status: 'Pending',
    icon: faCheckCircle,
  },
];

// TODO: REPLACE MOCK DATA BOSON-333
// Generate random procedure codes for each appointment (1-4 codes)
export const getRandomProcedureCodes = () => {
  const numCodes = Math.floor(Math.random() * 4) + 1; // 1-4 codes
  const shuffled = [...mockProcedureCodes].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, numCodes);
};
